import * as React from 'react';
import { Redirect } from 'react-router';
import loadable from '@loadable/component';
import withMicroFrontendProps, { SEOHead } from 'AppShell/Microfrontend';
import useBellaTranslator from 'Client/hooks/useTranslator';
import { SEO_CONSTANTS } from 'Client/components/ListingPage/services/seo/constant';
import useRouter from 'AppShell/hooks/useRouter';
import routes from 'Common/routes/paths';
import { ensureEndingSlash } from 'Client/urlService';
import useShowPromoBarBanner from 'Client/hooks/flags/useShowPromoBarBanner';

const InteriorDesignService = loadable(() => import('mf-interior-design-service/Main'));

const InteriorDesignServiceWithBellaProps = withMicroFrontendProps(InteriorDesignService, 'mf-interior-design-service');

export const IDSPaths = {
    LANDING_PAGE: {
        HERO_BLOCK: '#hero-block',
        OUR_PROJECTS_BLOCK: '#our-projects',
        PROJECT_SLIDER_BLOCK: '#project-slider',
        HOW_IT_WORKS_BLOCK: '#how-it-works',
        PRICE_TIERS_BLOCK: '#price-tiers',
        WHAT_YOU_GET_BLOCK: '#what-you-get',
        REVIEWS_BLOCK: '#reviews',
        FAQ_BLOCK: '#faq-block',
        PRESS_BLOCK: '#press',
    },
    QUESTIONNAIRE_PAGE: 'wizard/project',
};

const InteriorDesignServiceMicroFrontend = () => {
    const t = useBellaTranslator();
    const { isAppWebviewPage, location } = useRouter();
    const isClubBarBannerShown = useShowPromoBarBanner();

    if (location.pathname.startsWith(routes.INTERIOR_DESIGN_SERVICE_OLD) && !isAppWebviewPage) {
        return <Redirect to={ensureEndingSlash(routes.INTERIOR_DESIGN_SERVICE)} />;
    }

    return (
        <>
            <SEOHead>
                <title>{isAppWebviewPage ? t('Studio Title - Apps') : t('WestwingNow - Interior Service')}</title>
                <meta
                    name={SEO_CONSTANTS.descriptionMetaName}
                    content={t('WestwingNow - Interior Service description')}
                />
            </SEOHead>
            <InteriorDesignServiceWithBellaProps isClubBarBannerShown={isClubBarBannerShown} />
        </>
    );
};

export default InteriorDesignServiceMicroFrontend;
